export class TamUser {
    public Id: string
    public CompanyId: number
    public Login: string
    public Fullname: string
    public FirstName: string
    public LastName: string
    public Email: string
    public IsAdmin: boolean

    constructor () {
      this.Id = ''
      this.CompanyId = -1
      this.Login = ''
      this.Fullname = ''
      this.FirstName = ''
      this.LastName = ''
      this.Email = ''
      this.IsAdmin = false
    }

    initialize (jsonJwtPayload: any) {
      this.Id = jsonJwtPayload.id
      this.CompanyId = jsonJwtPayload.companyId
      this.Login = jsonJwtPayload.nickname
      this.Fullname = jsonJwtPayload.name
      this.FirstName = jsonJwtPayload.given_name
      this.LastName = jsonJwtPayload.family_name
      this.Email = jsonJwtPayload.email
      this.IsAdmin = jsonJwtPayload.isAdmin
      return this
    }
}
